export enum VelocityRate {
  Good = 'Good',
  Fast = 'Fast',
  Slow = 'Slow',
  Empty = 'Empty',
}